<script>
    export default {
        name: "ContactFormula",
        props:{
            initScope: {
                type: String,
                default: "front-page"
            },
            inModal: {
                type: Boolean,
                default: true
            },
            scope: {
                type: String,
                default: 'front-page'
            },
            boundToCalculation: {
                type: String,
                default: null
            }
        },
        data() {
          const formData = Laravel.EventSuite.user
            ? {
                firstname: Laravel.EventSuite.user.user.first_name,
                lastname: Laravel.EventSuite.user.user.last_name,
                email: Laravel.EventSuite.user.user.email,
                company: Laravel.EventSuite.user.company && Laravel.EventSuite.user.company.name,
                phone: this.phoneNumberToString(Laravel.EventSuite.user.user.phones),
                msg: '',
                calculationPublicId: null
              }
            : {
                firstname: '',
                lastname: '',
                email: '',
                company: '',
                phone: '',
                msg: '',
                calculationPublicId: null
              }
          return {
            formData: formData,
            isSending: false,
            contactDescriptionType: 'front-page',
            emailTo: null
        }},
        computed: {
            scopeObject() {
                switch(this.scope) {
                    case "request-offer":
                        return {
                            headline: "Angebot anfordern",
                            showDescriptionText: false,
                            showCalculationRelation: true,
                            inModal: true,
                            form_type: '2',
                            styleObject: {
                                maxWidth: "540px"
                            }
                        }
                    case "request-consultation":
                        return {
                            headline: "Beratung anfordern",
                            showDescriptionText: false,
                            showCalculationRelation: true,
                            inModal: true,
                            form_type: '2',
                            styleObject: {
                                maxWidth: "540px"
                            }
                        }
                    case "front-page":
                        return {
                            headline: this.$t('contact.contact_headline'),
                            showDescriptionText: true,
                            showCalculationRelation: false,
                            inModal: false,
                            styleObject: {
                                maxWidth: "1260px"
                            },
                            columns:'one-column'
                        }
                    case "contact":
                        return {
                            headline: this.$t('contact.contact_headline'),
                            showDescriptionText: true,
                            showCalculationRelation: false,
                            inModal: true,
                            styleObject: {
                                maxWidth: "960px"
                            }
                        }
                    case "in-calc-contact":
                        return {
                            headline: this.$t('contact.contact_headline'),
                            showDescriptionText: true,
                            showCalculationRelation: true,
                            inModal: true,
                            form_type: '3',
                            styleObject: {
                                maxWidth: "960px"
                            }
                        }
                    case "foreign-contact":
                        return {
                            headline: this.$t('contact.contact_headline'),
                            showDescriptionText: false,
                            showCalculationRelation: false,
                            inModal: true,
                            styleObject: {
                                maxWidth: "540px"
                            }
                        }
                    case "error-feedback":
                        return {
                            headline: "Error-Feedback",
                            showDescriptionText: true,
                            showCalculationRelation: false,
                            inModal: true,
                            form_type: '3',
                            styleObject: {
                                maxWidth: "960px"
                            }
                        }
                    default:
                        return false
                }
            },
            eventName() {
                let evName = this.$store.$data.calculationName
                if(evName === '') {
                    return ''
                } else {
                    return this.$store.$data.calculationName
                }
            },
            calculationPublicId() {
                //console.log(this.calculationPublicId, this.$store.publicId)
                if(this.boundToCalculation) {
                    return this.boundToCalculation
                }

                if(this.$store.publicId) {
                    return this.$store.publicId
                }

                return null
            },
            isValid() {
                if(this.isSending) {
                    return false
                }

                if(this.formData && this.formData.firstname && this.formData.lastname && this.formData.email && this.formData.msg) {
                    if(this.formData.firstname.length > 0 && this.formData.lastname.length > 0 &&  this.formData.email.length > 0 && this.validateEmail(this.formData.email) &&  this.formData.msg.length > 0) {
                        return true
                    }
                }

                return false
            },
            sendBtnText: function() {
                if(this.isSending) {
                    return "Loading..."
                }

                return this.$t('general.send')
            }
        },
        watch: {
          scope: function (scope) {
            this.formData.msg = ''

            if (scope === 'request-offer') {
              this.formData.msg = contactModalRequestOfferText
            }

            if (scope === 'request-consultation') {
              this.formData.msg = contactModalRequestConsultationText
            }

            if (scope === 'in-calc-contact') {
              this.formData.msg = contactModalLocationText
            }

            if (scope === 'foreign-contact') {
              //contactTextField.val("");
            }
          },
          emailTo: function (emailTo) {
            $('#contact-email-to').val(emailTo)
          }
        },
        mounted() {
           // this.formData.calculationPublicId = this.calculationPublicId
        },
        methods: {
            setEmailTo(email) {
                this.emailTo = email
            },
            sendMail() {
                this.isSending = true

                $('.send-contact-mail').text('Loading...')

                axios.post('/api/sendcontactmails', this.formData).then(() => {
                    this.isSending = false
                })
            },
            phoneNumberToString(phones)
            {
              console.log(phones)
              if (phones && phones.length > 0) {
                const phoneNumber = phones[0]
                return '+' + phoneNumber.country_code + ' ' + phoneNumber.phone_number
              }
              return ''
            },
            validateEmail(email) 
            {
                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return re.test(String(email).toLowerCase())
            }
        },
        template: "#contact-template",
    }
</script>